<div [class]="containerClasses">
  <div
    class="flex w-full items-center justify-between gap-6 px-4 transition-all duration-300"
    [class.blur-md]="loading"
    [class.opacity-40]="loading"
    [class.animate-pulse]="loading"
  >
    @for (item of items; track item.label) {
      <div class="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs">
        <span class="text-text-half-dimmed">{{ item.label }}</span>
        <span class="font-bold text-text-primary">{{ item.value }}</span>
        @if (item.change) {
          <!-- Change indicator, inlined to match this bar's own visual language rather than a shared chip component -->
          <span
            [class]="'inline-flex items-center gap-1 font-semibold ' + (item.change.direction === 'up' ? 'text-text-success' : 'text-text-destructive')"
          >
            @if (item.change.direction === 'up') {
              <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M6 2 10.5 9H1.5z" /></svg>
            } @else {
              <svg width="10" height="10" viewBox="0 0 12 12" fill="currentColor" aria-hidden="true"><path d="M6 10 1.5 3h9z" /></svg>
            }
            <span>{{ item.change.percent }}%</span>
          </span>
        }
      </div>
    } @empty {
      <span class="text-xs text-text-half-dimmed">No data available</span>
    }
  </div>
</div>
